module.exports = __webpack_public_path__ + "static/media/ai.381a475b.svg";